<template>
    <div class="invoice-layout">
        <div v-if="isLocal">
            选中项条数： {{salesReturn.selection.length}}
            <div>
                <Button type="primary" @click="selecionLog">输出选中项</Button>
            </div>
        </div>
        <Row v-if="step === 1">
            <Col span="8">
                <Form :model="gscInvoiceForm" ref="gscinvoiceForm" :rules="gscInvoiceRules" :label-width="110">
                    <FormItem :label="$t('gscInvoice.t1')" prop="orgId"> <!--买方-->
                        <Select v-model="gscInvoiceForm.orgId" 
                                filterable
                                @on-change="ouChange">
                            <Option 
                                v-for="item in ouList" 
                                :value="item.value" 
                                :label="item.label" 
                                :key="item.value">
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('gscInvoice.t28')" prop="vendorSiteCode"> <!--地点-->
                        <Select v-model="gscInvoiceForm.vendorSiteCode" filterable>
                            <Option 
                                v-for="item in vendorSiteList" 
                                :value="item.value" 
                                :label="item.label" 
                                :key="item.value">
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('gscInvoice.t2')" prop="invoiceType"> <!--发票类型-->
                        <Select v-model="gscInvoiceForm.invoiceType" filterable>
                            <Option 
                                v-for="item in INT_GSC_INVOICE_SOURCE_TYPE" 
                                :value="item.code" 
                                :label="item.label" 
                                :key="item.value">
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('gscInvoice.t17')" prop="currencyCode"> <!--币种-->
                        <Select v-model="gscInvoiceForm.currencyCode" filterable> 
                            <Option 
                                v-for="item in currencyCodeList" 
                                :value="item.value" 
                                :label="item.label" 
                                :key="item.value">
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem :label="$t('gscInvoice.t32')" prop="endDateFormart"> <!--截止日期-->
                        <DatePicker
                             style="width: 100%" 
                             type="date"
                             format="yyyy-MM-dd"
                             v-model="gscInvoiceForm.endDateFormart"
                             @on-change="endDateChange">
                        </DatePicker>
                    </FormItem>
                    <FormItem :label="$t('gscInvoice.t33')" prop="taxCode">  <!--税率-->
                        <Select v-model="gscInvoiceForm.taxCode" 
                                filterable
                                @on-change="taxCodeChange">
                            <Option 
                                v-for="item in taxRateCodeList" 
                                :value="item.code"
                                :label="`${item.label} - ${item.value}`"
                                :key="item">
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem>
                        <Button type="default" style="margin-right: 10px;" @click="goBack">{{$t('gscInvoice.t20')}}</Button>
                        <Button type="primary" :loading="loading" @click="invoiceAddNext">{{$t('gscInvoice.t34')}}</Button>
                    </FormItem>
                </Form>
            </Col>
        </Row>
        <template v-if="step === 2">
            <Row style="text-align:right">
                <Col span="24">
                    <Button type="default" class="mr10" @click="goBack">{{ $t('gscInvoice.t31') }}</Button>
                    <Button type="primary" class="mr10" @click="step = 1" v-if="isNew">{{ $t('gscInvoice.t35') }}</Button>
                    <Button type="primary" class="mr10" :loading="loading" @click="tcmSave" :disabled="skjInvoice.tableData.length === 0" v-if="taxCanEdit">{{ $t('gscInvoice.t89') }}</Button>
                    <!-- <Button type="primary" class="mr10" :loading="loading" @click="tcmSubmit" :disabled="skjInvoice.tableData.length === 0" v-if="taxCanEdit">{{ $t('gscInvoice.t90') }}</Button> -->
                    <Button type="primary" class="mr10" :loading="loading" :disabled="!saveFlag" v-if="isNew" @click="ispSave">{{ $t('gscInvoice.t36') }}</Button>
                    <!-- <Button type="primary" class="mr10" :loading="loading" v-if="canSubmit" @click="ispSubmit('gscInvoiceDetail')">{{$t('gscInvoice.t18')}}</Button> -->
                    <Button type="primary" class="mr10" :loading="loading"  v-if="canSubmit" @click="tcmSubmit">{{ $t('gscInvoice.t90') }}</Button>
                </Col>
            </Row>
            <Form class="mt10" :model="gscInvoiceForm" :label-width="110">
                <Row>
                    <Col span="6">
                        <FormItem :label="$t('gscInvoice.t1')" prop="orgId"> <!--买方-->
                            <Select v-model="gscInvoiceForm.orgId"
                                    disabled>
                                <Option 
                                    v-for="item in ouList" 
                                    :value="item.value" 
                                    :label="item.label" 
                                    :key="item.value">
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t91')" prop="ispInvoiceCode"> <!--GSC发票号-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.ispInvoiceCode">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem :label="$t('gscInvoice.t10')" prop="invoiceType"> <!--GSC发票类型-->
                            <Select v-model="gscInvoiceForm.invoiceType" disabled>
                                <Option 
                                    v-for="item in INT_GSC_INVOICE_SOURCE_TYPE" 
                                    :value="item.code" 
                                    :label="item.label" 
                                    :key="item.value">
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t62')" prop="status"> <!--状态-->
                            <Select v-model="gscInvoiceForm.status" disabled>
                                <Option 
                                    v-for="item in INT_GSC_INVOICE_STATUS" 
                                    :value="item.value" 
                                    :label="item.label" 
                                    :key="item.value">
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t64')" prop="totalAmount"> <!--发票含税金额-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.totalAmount">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t14')" prop="taxRate">  <!--税率-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.taxRate">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t15')" prop="taxAmount"> <!--税额-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.taxAmount">
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t63')" prop="noTaxAmount">  <!--发票不含税金额-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.noTaxAmount">
                            </Input>
                        </FormItem>
                    </Col>
                    <!-- <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t68')" prop="overdueAmount">  
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.overdueAmount">
                            </Input>
                        </FormItem>
                    </Col> -->
                    <Col span="6">
                        <FormItem :label="$t('gscInvoice.t17')" prop="currencyCode"> <!--币种-->
                            <Select v-model="gscInvoiceForm.currencyCode" disabled>
                                <Option 
                                    v-for="item in currencyCodeList" 
                                    :value="item.value" 
                                    :label="item.label" 
                                    :key="item.value">
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t65')" prop="currencyConversionRate"> 
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.currencyConversionRate">
                            </Input>
                        </FormItem>
                    </Col> -->
                    <!-- <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t66')" prop="currencyConversionDate">
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.currencyConversionDate">
                            </Input>
                        </FormItem>
                    </Col> -->
                    <Col span="6" v-if="!isNew">
                        <FormItem :label="$t('gscInvoice.t67')" prop="comments"> <!--备注-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.comments">
                            </Input>
                        </FormItem>
                    </Col>




                    <Col span="6" v-if="isNew">
                        <FormItem :label="$t('gscInvoice.t37')" prop="penaltyPercent"> <!--最大高低开比例-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.penaltyPercent">
                            </Input>
                        </FormItem>
                    </Col>
                     <!--开票限额-->
                    <!-- <Col span="6" v-if="isNew">
                        <FormItem :label="$t('gscInvoice.t38')" prop="ispinvAmtLimit"> 
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.ispinvAmtLimit">
                            </Input>
                        </FormItem>
                    </Col> -->
                    <Col span="6" v-if="isNew">
                        <FormItem :label="$t('gscInvoice.t39')" prop="totalAmount">  <!--汇总金额-->
                            <Input type="text"
                                   disabled
                                   v-model="gscInvoiceForm.totalAmount">
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <Tabs v-model="tableTabVal" class="mt10" v-if="isNew">
                <TabPane :label="$t('gscInvoice.t40')" name="tab1" v-if="!(isNew && isPenaltyInvoice)">
                    <Button class="ml20" type="primary" :loading="salesReturn.loading" @click="salesReturnExport">{{ $t('gscInvoice.t42') }}</Button>
                    <Checkbox class="ml20" v-model="salesReturn.allSelectFlag" @on-change="getAllRequired"> {{ $t('gscInvoice.t108') }}</Checkbox> <!--全选-->

                    <template v-if="isCG">
                        <!--母卷号-->
                        <span class="ml20">{{$t('gscInvoice.t127')}}：</span>
                        <Input
                            type="text"
                            v-model="materialDetailNo"
                            size="small"
                            :placeholder="$t('createDeliveryOrderByOrder.t50')"
                            style="width:200px;">
                        </Input>
                        <!--物流单号-->
                        <span class="ml20">{{$t('gscInvoice.t128')}}：</span>
                        <Input
                            type="text"
                            v-model="logisticsTrackingNo"
                            size="small"
                            :placeholder="$t('createDeliveryOrderByOrder.t50')"
                            style="width:200px;">
                        </Input>
                        <Button type="primary" class="ml20" :loading="salesReturn.loading" @click="queryIapReceips2Bymater">{{$t('page.query.search')}}</Button>
                    </template>

                    <Button type="primary" style="float:right" @click="goNoPriceDetail">{{ $t('gscInvoice.t117') }}</Button>
                    <!-- <Button class="ml20" type="primary" @click="getAllRequired">{{ $t('gscInvoice.t108') }}</Button>  -->
                    <!--接收退货明细-->
                    <m-assembly-table 
                        ref='salesReturn'
                        :columns='salesReturnColumns'
                        :data='salesReturn.tableData'
                        :loading='salesReturn.loading'
                        :currentPage='salesReturn.settings.currentPage'
                        :pageSize='salesReturn.settings.pageSize'
                        :total='salesReturn.settings.total'
                        :settings='salesReturn.settings'
                        noDataText=""
                        @onSelect="salesReturnOnSelect"
                        @onSelectionChange="salesReturnOnSelectChange"
                        @onSelectCancel="salesReturnOnCancel"
                        @onSelectAll="salesReturnOnSelectAll"
                        @onPageSizeChange='salesReturnOnPageSizeChange'
                        @onCurrentPageChange='salesReturnOnPageChange'
                    >
                    </m-assembly-table>
                    <div class="invoice-nodata" v-if="salesReturn.tableData.length === 0">
                        {{$t('gscInvoice.t118')}}<span @click="goNoPriceDetail">{{ $t('gscInvoice.t117') }}</span>{{ $t('gscInvoice.t119') }}
                    </div>
                </TabPane>
                <TabPane :label="$t('gscInvoice.t41')" name="tab2">
                    <Checkbox v-if="isPenaltyInvoice" class="ml20" v-model="penaltyAllFlag" @on-change="penaltyAllOnChange"> {{ $t('gscInvoice.t108') }}</Checkbox> <!--全选-->
                    <!--罚扣款-->
                    <m-assembly-table 
                        ref='penaltyDeduction'
                        :columns='penaltyDeductionFilter'
                        :data='penaltyDeduction.tableData'
                        :loading='penaltyDeduction.loading'
                        :currentPage='penaltyDeduction.settings.currentPage'
                        :pageSize='penaltyDeduction.settings.pageSize'
                        :total='penaltyDeduction.settings.total'
                        :settings='penaltyDeduction.settings'
                        @onPageSizeChange='penaltyDeductionOnPageSizeChange'
                        @onCurrentPageChange='penaltyDeductionOnPageChange'
                        @onSelectionChange="penaltyDeductionOnSelect"
                    >
                    </m-assembly-table>
                </TabPane>
            </Tabs>


            <Collapse v-model="collapseVal" v-if="!isNew">
                <Panel name="1">
                    {{$t('gscInvoice.t69')}}
                    <div slot="content">
                        <!--税控机发票-->
                        <Button style="margin-left:18px;" type="primary" :disabled="!taxCanEdit || (skjInvoice.tableData.length >= 1 && !isCG)" @click="addTcmLine">{{ this.$t('gscInvoice.t92') }}</Button><!--新增行-->
                        <m-assembly-table 
                            ref='skjInvoice'
                            :columns='skjInvoiceColumns'
                            :data='skjInvoice.tableData'
                            :loading='skjInvoice.loading'
                            :currentPage='skjInvoice.settings.currentPage'
                            :tableButtons='skjInvoice.tableButtons'
                            :pageSize='skjInvoice.settings.pageSize'
                            :total='skjInvoice.settings.total'
                            :settings='skjInvoice.settings'
                            @onPageSizeChange='skjInvoiceOnPageSizeChange'
                            @onCurrentPageChange='skjInvoiceOnPageChange'
                        >
                        <div slot="total">
                            <Table
                                 v-if="isCG && skjInvoice.tableData.length > 0"
                                class="gsc-invoice-total-table"
                                :show-header="false"
                                :columns="skjInvoiceColumns2"
                                :data="skjInvoice.tableData2"
                                border
                                size="small"
                            ></Table>
                        </div>
                        </m-assembly-table>
                    </div>
                </Panel>
                <Panel name="1">
                    {{$t('gscInvoice.t70')}}<span class="ml20">{{ $t('gscInvoice.t71') }} {{ itemAmountSum }}</span>
                    <div slot="content">
                        <Tabs v-model="tableTabVal2" v-if="!isNew">
                            <TabPane :label="$t('gscInvoice.t70')" name="tab1">
                                <!--ISP发票行-->
                                <m-assembly-table 
                                    ref='ispLines'
                                    :columns='ispLinesColumns'
                                    :data='ispLines.tableData'
                                    :loading='ispLines.loading'
                                    :currentPage='ispLines.settings.currentPage'
                                    :pageSize='ispLines.settings.pageSize'
                                    :total='ispLines.settings.total'
                                    :settings='ispLines.settings'
                                    :tableButtons="ispLines.tableButtons"
                                    @onPageSizeChange='ispLinesOnPageSizeChange'
                                    @onCurrentPageChange='ispLinesOnPageChange'
                                >
                                </m-assembly-table>
                            </TabPane>
                            <TabPane :label="$t('gscInvoice.t72')" name="tab2">
                                <!--物料汇总-->
                                <m-assembly-table 
                                    ref='itemLines'
                                    :columns='itemLines.columns'
                                    :data='itemLines.tableData'
                                    :loading='itemLines.loading'
                                    :currentPage='itemLines.settings.currentPage'
                                    :pageSize='itemLines.settings.pageSize'
                                    :total='itemLines.settings.total'
                                    :settings='itemLines.settings'
                                    @onPageSizeChange='itemLinesOnPageSizeChange'
                                    @onCurrentPageChange='itemLinesOnPageChange'
                                >
                                </m-assembly-table>
                            </TabPane>
                             <!--接收单汇总-->
                            <!-- <TabPane :label="$t('gscInvoice.t73')" name="tab3">
                     
                                <m-assembly-table 
                                    ref='acceptLines'
                                    :columns='acceptLines.columns'
                                    :data='acceptLines.tableData'
                                    :loading='acceptLines.loading'
                                    :currentPage='acceptLines.settings.currentPage'
                                    :pageSize='acceptLines.settings.pageSize'
                                    :total='acceptLines.settings.total'
                                    :settings='acceptLines.settings'
                                    @onSubmit='acceptLinesOnSubmit'
                                    @onPageSizeChange='acceptLinesOnPageSizeChange'
                                    @onCurrentPageChange='acceptLinesOnPageChange'
                                >
                                </m-assembly-table> -->
                            <!-- </TabPane> -->
                        </Tabs>
                    </div>
                </Panel>
                <Panel name="3">
                    {{$t('gscInvoice.t78')}}<span class="ml20">{{ $t('gscInvoice.t79') }} {{ penaltyAmountSum }}</span>
                    <div slot="content">
                        <!--罚扣款行-->
                        <m-assembly-table 
                            ref='kfkLines'
                            :columns='kfkLines.columns'
                            :data='kfkLines.tableData'
                            :loading='kfkLines.loading'
                            :currentPage='kfkLines.settings.currentPage'
                            :pageSize='kfkLines.settings.pageSize'
                            :total='kfkLines.settings.total'
                            :settings='kfkLines.settings'
                            :tableButtons="kfkLines.tableButtons"
                            @onPageSizeChange='kfkLinesOnPageSizeChange'
                            @onCurrentPageChange='kfkLinesOnPageChange'
                        >
                        </m-assembly-table>
                    </div>
                </Panel>
            </Collapse>
        </template>
    </div>
</template>
<script>
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import {getOuList, queryIntTimeZone, exportExcel} from './financialAccounting';
import {queryVendorSite, queryCurrencyCode} from './isp';
import axios from 'axios';
import moment from 'moment';
import BigNumber from 'bignumber.js';
export default {
    name: 'gscInvoiceCommon',
    components: { 
        mAssemblyTable 
    },
    props: {
        isNew: {
            type: Boolean,
            default: false
        },
        isEdit: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        taxRateCodeList() {
            const { orgId } = this.gscInvoiceForm;
            return this.INT_TAX_RATE.filter((item) => item.attribute1 && item.attribute1.includes(orgId));
        },
        taxCanEdit () {
            return ['Submitted', 'Rejected'].includes(this.gscInvoiceForm.status) && this.isEdit;
        },
        canSubmit () {
            return ['New', 'Rejected'].includes(this.gscInvoiceForm.status);
        },
        saveFlag () {
            let {invoiceType} = this.gscInvoiceForm;
            let selectionLength = this.salesReturn.selection.length;
            if (invoiceType === 'Penalty Invoice') {
                return selectionLength >= 0;
            } else {
                return selectionLength !== 0;
            }
        },
        itemAmountSum () {
            return this.gscInvoiceForm.itemAmountSum || 0;
        },
        penaltyAmountSum () {
            return this.gscInvoiceForm.penaltyAmountSum || 0;
        },
        /* 小数位 */
        decimalPlaces() {
            const obj = this.currencyCodeList.find((item) => item.code === this.gscInvoiceForm.currencyCode);
            return obj ? obj.attribute1 || 2 : 2;
        },
        /* 小数位限制 */
        decimalPlaceRestrictionRule() {
            return new RegExp(this.decimalPlaces > 0 ? `^-?(?:\\d+(?:\\.\\d{1,${this.decimalPlaces}})?)$` : `^-?\\d+$`);
        },
        decimalPlacesWarning() {
            return `${this.$t('gscInvoice.t102') + this.$t('gscInvoice.t124') + this.decimalPlaces + this.$t('gscInvoice.t125')}`;
        },
		/* 独立罚扣展示字段 */
        penaltyDeductionFilter() {
            const columns = this.penaltyDeduction.columns.columns;
            return {
                columns: !this.isPenaltyInvoice ? columns.filter((item) => item.type !== 'selection') : columns,
            };
        },
		/* 是否独立罚扣 */
        isPenaltyInvoice() {
            return this.gscInvoiceForm.invoiceType === 'Penalty Invoice';
        },
        /* 汇总金额 */
        totalAmount() {
            const total = this.penaltyAllData.reduce((prev, next) => {
                if (this.penaltyAllFlag || this.penaltyIds.includes(next.penaltyId)) {
                    return BigNumber(prev).plus(BigNumber(next.amount));
                } else {
                    return prev;
                }
            }, 0);
            return BigNumber(total).times(-1); 
        },
        /* 是否采购中心 */
        isCG() {
            return this.INT_CGZX_ORG.some((item) => item.value === this.gscInvoiceForm.orgId);
            // return true;
        },
        salesReturnColumns() {
            /* 非采购中心，过滤部分字段 */
            const columns = this.filterColumns('salesReturn');
            return {
                columns,
            };
        },
        /* 母卷号强控开关 */
        mjControlSwitch() {
            /*
                如果启动了ALL，则全部启用，并排除OU内的供应商；
                如果没有ALL，则根据OU内供应商启用；
            */
            let flag = false;
            const dict = this.INT_MASTER_ROLL_CONTROL.filter((item) => item.value.toUpperCase() === 'Y')
            if (dict.some((item) => item.code.toUpperCase() === 'ALL')) {
                flag = true;
            }
            if (dict.some((item) => item.code === this.gscInvoiceForm.orgId && item.attribute1.includes(this.vendorCode))) {
                flag = !flag;
            }
            return flag;
        },
        /* 开票数量强控开关 */
        invoiceQtySwitch() {
            return this.INT_INVOICE_QTY_CONTROL.some((item) => item.code === this.gscInvoiceForm.orgId);
        },
        ispLinesColumns() {
            /* 非采购中心，过滤部分字段 */
            const columns = this.filterColumns('ispLines');
            return {
                columns,
            };
        },
        skjInvoiceColumns() {
            /* 根据采购中心强控标识，判断是否显示“开票数量” */
            const columns = this.invoiceQtySwitch ? this.skjInvoice.columns.columns : this.skjInvoice.columns.columns.filter((item) => item.key !== 'invoiceQty');
            return {
                columns,
            };
        },
        skjInvoiceColumns2() {
            return this.skjInvoice.columns2.filter((item) => !(this.invoiceQtySwitch ? [] : ['invoiceQty']).includes(item.key));
        },
    },
    watch: {
        'salesReturn.tableData' (newVal) {
            this.autoSelect();
        },
        'salesReturn.selection' (newVal) {
            this.autoSelect();
        },
        'skjInvoice.tableData'() {
            this.countFun();
        },
    },
    data () {
        return {
            materialDetailNo: '', // 母卷号
            logisticsTrackingNo: '', // 物流单号
            INT_MASTER_ROLL_CONTROL: [],
            INT_INVOICE_QTY_CONTROL: [],
            INT_CGZX_ORG: [],
            penaltyAllData: [], // 所有罚扣数据
            penaltyIds: [],
            penaltyAllFlag: false, // 罚扣全选标识
            offsetTime: 0,
            isLocal: false,
            collapseVal: [1, 2, 3],
            step: 1,
            loading: false,
            gscInvoiceForm: {
                orgId: '',
                vendorSiteCode: '',
                invoiceType: '',
                currencyCode: '',
                endDate: '',
                endDateFormart: '',
                taxCode: '',
                penaltyPercent: '',
                ispinvAmtLimit: '',
                totalAmount: 0,
                status: '',
                taxAmount: '',
                taxRate: '',
                noTaxAmount: '',
                overdueAmount: '',
                currencyConversionRate: '',
                currencyConversionDate: '',
                comments: '',
                ispInvoiceCode: '',
            },
            gscInvoiceRules: {
                orgId: [
                    {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change'}
                ],
                vendorSiteCode: [
                    {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change'}
                ],
                invoiceType: [
                    {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change'}
                ],
                currencyCode: [
                    {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change'}
                ],
                // endDateFormart: [
                //     {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change', type: 'date'}
                // ],
                taxCode: [
                    {required: true, message: this.$t('gscInvoice.t30'), trigger: 'change'}
                ]
            },
            ouList: [],
            vendorSiteList: [],
            INT_GSC_INVOICE_SOURCE_TYPE: [],
            currencyCodeList: [],
            INT_GSC_INVOICE_STATUS: [],
            tableTabVal: 'tab1',
            salesReturn: {
                allSelectFlag: false,
                selection: [],
                mustSelection: [],
                columns: {
                    columns: [
                        {
                            type: 'selection',
                            width: 30,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t43'), // 事务类型
                            key: 'transactionType',
                            minWidth: 80,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t44'), // 事务日期
                            key: 'transactionDate',
                            minWidth: 100,
                            align: 'center',
                            render: (h, params) => {
                                let {transactionDate} = params.row;
                                return h('span', moment(transactionDate).format('YYYY-MM-DD'));
                            }
                        },
                        {
                            title: this.$t('gscInvoice.t45'), // 接收单号
                            key: 'receiptNum',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t46'), // 订单号
                            key: 'poNum',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t129'), // 供应商合同号
                            key: 'supplierContractNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t130'), // 供应商合同子项号
                            key: 'contractSubitemNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t127'), // 母卷号
                            key: 'materialDetailNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t128'), // 物流单号
                            key: 'logisticsTrackingNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        // {
                        //     title: this.$t('gscInvoice.t47'), // 接收行号
                        //     key: '',
                        //     minWidth: 60,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t48'), // 接收日期
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t49'), // 送货单号
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        {
                            title: this.$t('gscInvoice.t50'), // 物料编码
                            key: 'itemCode',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t51'), // 物料描述
                            key: 'itemName',
                            minWidth: 200,
                            tooltip: true
                        },
                        {
                            title: this.$t('gscInvoice.t52'), // 单位
                            key: 'itemUom',
                            minWidth: 50
                        },
                        {
                            title: this.$t('gscInvoice.t53'), // 价格
                            key: 'price',
                            minWidth: 50,
                            align: 'right'
                        },
                        {
                            title: this.$t('gscInvoice.t54'), // 数量
                            key: 'quantity',
                            minWidth: 50,
                            align: 'right'
                        },
                        {
                            title: this.$t('gscInvoice.t55'), // 金额
                            key: 'lineAmount',
                            minWidth: 50,
                            align: 'right',
                            render: (h, params) => {
                                const { lineAmount } = params.row;
                                return h('span', lineAmount ? parseFloat(lineAmount.toFixed(2)) : '');
                            },
                        },
                        {
                            title: this.$t('gscInvoice.t56'), // 币种
                            key: 'currencyCode',
                            minWidth: 50,
                            align: 'right'
                        }
                    ]
                },
                tableData: [],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            penaltyDeduction: {
                columns: {
                    columns: [
                        {
                            type: 'selection',
                            width: 35,
                            align: 'center',
                        },
                        {
                            title: this.$t('gscInvoice.t57'), // 罚扣款编号
                            key: 'penaltyNumber',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t58'), // 罚扣款类型
                            key: 'penaltyTypeCode',
                            minWidth: 60,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t59'), // 罚扣款标题
                            key: 'penaltyTitle',
                            minWidth: 100
                        },
                        {
                            title: this.$t('gscInvoice.t96'), // 罚扣款类型描述
                            key: 'penaltyTypeName',
                            minWidth: 100,
                            tooltip: true
                        },
                        {
                            title: this.$t('gscInvoice.t97'), // 扣款金额
                            key: 'amount',
                            minWidth: 100
                        },
                        {
                            title: this.$t('gscInvoice.t98'), // 扣款日期
                            key: 'creationDate',
                            minWidth: 100,
                            render: (h, params) => {
                            let {creationDate} = params.row;
                            return h('span', creationDate && moment(creationDate).add(this.offsetTime, 'h').format('YYYY-MM-DD HH:mm:ss') || '');
                        }
                        },
                        {
                            title: this.$t('gscInvoice.t99'), // 罚扣款状态
                            key: 'status',
                            minWidth: 100
                        }
                    ]
                },
                tableData: [],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            skjInvoice: {
                columns: {
                    columns: [
                        {
                            renderHeader: (h) => {
                                return h('span', [
                                    h('span', {
                                        style: {
                                            color: 'red'
                                        }
                                    }, '* '),
                                    h('span', this.$t('gscInvoice.t74'))
                                ])
                            },
                            title: this.$t('gscInvoice.t74'), // 税控机发票编号
                            key: 'taxInvoiceNumber',
                            minWidth: 100,
                            align: 'center',
                            render: (h, params) => {
                                if (this.taxCanEdit) {
                                    return h('Input', {
                                        props: {
                                            size: 'small',
                                            value: params.row.taxInvoiceNumber
                                        },
                                        on: {
                                            'on-blur': (event) => {
                                                let val = event.target.value;
                                                params.row.taxInvoiceNumber = val;
                                                this.skjInvoice.tableData[params.index] = params.row;
                                            }
                                        }
                                    })
                                } else {
                                    return h('span', params.row.taxInvoiceNumber);
                                }
                            }
                        },
                        // {
                        //     renderHeader: (h) => {
                        //         return h('span', [
                        //             h('span', {
                        //                 style: {
                        //                     color: 'red'
                        //                 }
                        //             }, '* '),
                        //             h('span', this.$t('gscInvoice.t94'))
                        //         ])
                        //     },
                        //     title: this.$t('gscInvoice.t94'), // 税控发票代码
                        //     key: 'taxInvoiceType',
                        //     minWidth: 100,
                        //     align: 'center',
                        //     render: (h, params) => {
                        //         if (this.taxCanEdit) {
                        //             return h('Input', {
                        //                 props: {
                        //                     size: 'small',
                        //                     value: params.row.taxInvoiceType
                        //                 },
                        //                 on: {
                        //                     'on-blur': (event) => {
                        //                         let val = event.target.value;
                        //                         params.row.taxInvoiceType = val;
                        //                         this.skjInvoice.tableData[params.index] = params.row;
                        //                     }
                        //                 }
                        //             });
                        //         } else {
                        //             return h('span', params.row.taxInvoiceType);
                        //         }
                        //     }
                        // },
                        {
                            renderHeader: (h) => {
                                return h('span', [
                                    h('span', {
                                        style: {
                                            color: 'red'
                                        }
                                    }, '* '),
                                    h('span', this.$t('gscInvoice.t77'))
                                ])
                            },
                            title: this.$t('gscInvoice.t77'), // 开票日期
                            key: 'createInvoiceDate',
                            minWidth: 100,
                            align: 'center',
                            render: (h, params) => {
                                if (this.taxCanEdit) {
                                    return h('DatePicker', {
                                        props: {
                                            type: 'date',
                                            size: 'small',
                                            value: params.row.createInvoiceDate,
                                            format: 'yyyy-MM-dd',
                                            transfer: true,
                                            editable: false,
                                            options: {
                                                disabledDate(date) {
                                                    return date && date.valueOf() > Date.now() || (date.valueOf() < new Date('2020-01-01').getTime() - 86400000);
                                                },
                                            },
                                        },
                                        on: {
                                            'on-change': (date) => {
                                                params.row.createInvoiceDate = date;
                                                this.skjInvoice.tableData[params.index] = params.row;
                                            },
                                            'on-clear': () => {
                                                params.row.createInvoiceDate = '';
                                                this.skjInvoice.tableData[params.index] = params.row;
                                            }
                                        }
                                    })
                                } else {
                                    return h('span', params.row.createInvoiceDate);
                                }
                            }
                        },
                        {
                            title: this.$t('gscInvoice.t15'), // 税额
                            key: 'taxAmount',
                            minWidth: 100,
                            align: 'center'
                            // render: (h, params) => {
                            //     let {noTaxAmount, totalAmount} = params.row;
                            //     return h('span', noTaxAmount &&  totalAmount && (noTaxAmount + totalAmount).toFixed(2));
                            // }
                        },
                        // {
                        //     title: this.$t('gscInvoice.t62'), // 状态
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        {
                            renderHeader: (h) => {
                                return h('span', [
                                    h('span', {
                                        style: {
                                            color: 'red'
                                        }
                                    }, '* '),
                                    h('span', this.$t('gscInvoice.t13'))
                                ])
                            },
                            title: this.$t('gscInvoice.t13'), // 不含税金额
                            key: 'noTaxAmount',
                            minWidth: 100,
                            align: 'center',
                            render: (h, params) => {
                                if (this.taxCanEdit) {
                                    return h('InputNumber', {
                                        props: {
                                            size: 'small',
                                            value: params.row.noTaxAmount,
                                        },
                                        style: {
                                            width: '100%'
                                        },
                                        on: {
                                            'on-change': (val) => {
                                                params.row.noTaxAmount = val;
                                                this.skjInvoice.tableData[params.index] = params.row;
                                                this.countFun();
                                            },
                                            'on-blur': () => {
                                                let val = params.row.noTaxAmount;
                                                if (!this.decimalPlaceRestrictionRule.test(val) || val === 0) {
                                                    if (val || val === 0) {
                                                        this.$Modal.error({
                                                            content: this.decimalPlacesWarning,
                                                        });
                                                    }
                                                    params.row.noTaxAmount = '';
                                                    this.skjInvoice.tableData[params.index] = params.row;
                                                    this.countFun();
                                                }
                                            }
                                        }
                                    })
                                } else {
                                    return h('span', params.row.noTaxAmount);
                                }
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return h('span', [
                                    h('span', {
                                        style: {
                                            color: 'red'
                                        }
                                    }, '* '),
                                    h('span', this.$t('gscInvoice.t16'))
                                ])
                            }, 
                            title: this.$t('gscInvoice.t16'), // 含税金额
                            key: 'totalAmount',
                            minWidth: 100,
                            align: 'center',
                            render: (h, params) => {
                                if (this.taxCanEdit) {
                                    return h('InputNumber', {
                                        props: {
                                            size: 'small',
                                            value: params.row.totalAmount,
                                        },
                                        style: {
                                            width: '100%'
                                        },
                                        on: {
                                            'on-change': (val) => {
                                                params.row.totalAmount = val;
                                                this.skjInvoice.tableData[params.index] = params.row;
                                                this.countFun();
                                            },
                                            'on-blur': () => {
                                                let val = params.row.totalAmount;
                                                if (!this.decimalPlaceRestrictionRule.test(val) || val === 0) {
                                                    if (val || val === 0) {
                                                        this.$Modal.error({
                                                            content: this.decimalPlacesWarning,
                                                        });
                                                    }
                                                    params.row.totalAmount = '';
                                                    this.skjInvoice.tableData[params.index] = params.row;
                                                    this.countFun();
                                                }
                                            }
                                        }
                                    })
                                } else {
                                    return h('span', params.row.totalAmount);
                                }
                            }
                        },
                        {
                            renderHeader: (h) => {
                                return h('span', [
                                    h('span', {
                                        style: {
                                            color: 'red'
                                        }
                                    }, '* '),
                                    h('span', this.$t('gscInvoice.t87'))
                                ])
                            }, 
                            title: this.$t('gscInvoice.t87'), // 开票数量
                            key: 'invoiceQty',
                            minWidth: 100,
                            align: 'center',
                            render: (h, params) => {
                                if (this.taxCanEdit) {
                                    return h('InputNumber', {
                                        props: {
                                            size: 'small',
                                            value: params.row.invoiceQty,
                                        },
                                        style: {
                                            width: '100%'
                                        },
                                        on: {
                                            'on-change': (val) => {
                                                params.row.invoiceQty = val;
                                                this.skjInvoice.tableData[params.index] = params.row;
                                                this.countFun();
                                            },
                                            'on-blur': () => {
                                                let val = params.row.invoiceQty;
                                                if (!this.decimalPlaceRestrictionRule.test(val) && val !== 0) {
                                                    this.$Modal.error({
                                                        content: this.decimalPlacesWarning,
                                                    });
                                                    params.row.invoiceQty = '';
                                                    this.skjInvoice.tableData[params.index] = params.row;
                                                    this.countFun();
                                                }
                                            }
                                        }
                                    })
                                } else {
                                    return priceToLocaleString(h, params.row.invoiceQty);
                                }
                            }
                        },
                        // {
                        //     title: this.$t('gscInvoice.t14'), // 税率
                        //     key: 'taxRate',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        {
                            title: this.$t('gscInvoice.t106'), // 删除
                            key: 'delete',
                            minWidth: 80,
                            align: 'center',
                            render: (h, params) => {
                                let {taxInvoiceDiscardFlag, taxInvoiceId} = params.row;
                                return h('Button', {
                                    props: {
                                        type: 'text',
                                        icon: 'trash-b',
                                        disabled: !this.taxCanEdit
                                    },
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                content: this.$t('gscInvoice.t107'),
                                                onOk: async () => {
                                                    if (this.taxCanEdit) {
                                                        if (taxInvoiceDiscardFlag) {
                                                            await this.tcmCancel(taxInvoiceId);
                                                        }
                                                        this.skjInvoice.tableData.splice(params.index, 1);
                                                    }
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                        }
                        // {
                        //     title: this.$t('gscInvoice.t75'), // 购方名称
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t76'), // 销方名称
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                    ]
                },
                columns2: [
                    {
                        key: 'taxInvoiceNumber',
                        minWidth: 100,
                    },
                    {
                        key: 'createInvoiceDate',
                        minWidth: 100,
                        align: 'center',
                    },
                    {
                        key: 'taxAmount',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    display: 'block',
                                    marginLeft: this.taxCanEdit ? '10px' : 0,
                                    textAlign: this.taxCanEdit ? 'left' : 'center',
                                },
                            }, params.row.taxAmount);
                        },
                    },
                    {
                        key: 'noTaxAmount',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    display: 'block',
                                    marginLeft: this.taxCanEdit ? '10px' : 0,
                                    textAlign: this.taxCanEdit ? 'left' : 'center',
                                },
                            }, params.row.noTaxAmount);
                        },
                    },
                    {
                        key: 'totalAmount',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    display: 'block',
                                    marginLeft: this.taxCanEdit ? '10px' : 0,
                                    textAlign: this.taxCanEdit ? 'left' : 'center',
                                },
                            }, params.row.totalAmount);
                        },
                    },
                    {
                        key: 'invoiceQty',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('span', {
                                style: {
                                    display: 'block',
                                    marginLeft: this.taxCanEdit ? '10px' : 0,
                                    textAlign: this.taxCanEdit ? 'left' : 'center',
                                },
                            }, params.row.invoiceQty);
                        },
                    },
                    {
                        key: 'delete',
                        minWidth: 80,
                    },
                ],
                tableButtons: {
                    customButtons: [
                        // {
                        //     label: this.$t('gscInvoice.t92'), // 新增行
                        //     type: 'primary',
                        //     icon: 'archive',
                        //     loading: false,
                        //     disabled: () => !this.taxCanEdit,
                        //     size: 'small',
                        //     click: (button) => {
                        //         this.addTcmLine();
                        //     }
                        // },
                        // {
                        //     label: this.$t('gscInvoice.t93'), // 批量导入
                        //     type: 'primary',
                        //     icon: 'archive',
                        //     loading: false,
                        //     disabled: false,
                        //     size: 'small',
                        //     click: (button) => {

                        //     }
                        // },
                    ]
                },
                tableData: [],
                tableData2: [
                    {
                        createInvoiceDate: `${this.$t('deliveryNoticeConfirm.t34')}:`,
                        taxAmount: 0,
                        noTaxAmount: 0,
                        totalAmount: 0,
                        invoiceQty: 0,
                    },
                ],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            kfkLines: {
                columns: {
                    columns: [
                        {
                            title: this.$t('gscInvoice.t57'), // 罚扣款编号
                            key: 'penaltyNumber',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t58'), // 类别
                            key: 'penaltyTypeName',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t80'), // 罚扣款说明
                            key: 'penaltyTitle',
                            minWidth: 100,
                            align: 'center'
                        },
                        // {
                        //     title: this.$t('gscInvoice.t60'), // 分期前金额
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        {
                            title: this.$t('gscInvoice.t61'), // 罚扣款金额
                            key: 'lineAmount',
                            minWidth: 100,
                            align: 'center'
                        }
                    ]
                },
                tableData: [],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                },
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('fpzInvaccCommon.t32'),
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                exportExcel(button, this, this.gscInvoiceForm, '/gscint/hw/ispInvoice/exportIspPenaltys');
                            }
                        }
                    ]
                }
            },
            tableTabVal2: 'tab1',
            ispLines: {
                columns: {
                    columns: [
                        // {
                        //     title: this.$t('gscInvoice.t81'), // 行号
                        //     key: 'lineNum',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t82'), // 是否超期
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t45'), // 接收单号
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t44'), // 事务日期
                        //     key: '',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        // {
                        //     title: this.$t('gscInvoice.t83'), // 订单编号
                        //     key: 'lineNum',
                        //     minWidth: 100,
                        //     align: 'center'
                        // },
                        {
                            title: this.$t('fpzInvaccCommon.t29'), // 接收单号
                            key: 'receiptNum',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t50'), // 物料编码
                            key: 'itemCode',
                            minWidth: 110,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t51'), // 物料描述
                            key: 'itemName',
                            minWidth: 200,
                            tooltip: true
                        },
                        {
                            title: this.$t('gscInvoice.t129'), // 供应商合同号
                            key: 'supplierContractNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t130'), // 供应商合同子项号
                            key: 'contractSubitemNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t127'), // 母卷号
                            key: 'materialDetailNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t128'), // 物流单号
                            key: 'logisticsTrackingNo',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('importNoticeCommon.t10'), // 采购订单号
                            key: 'poNum',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('processInspectionSearch.t3'), // 采购订单行号
                            key: 'poLineId',
                            minWidth: 80,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t84'), // 计量单位
                            key: 'itemUom',
                            minWidth: 50,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t85'), // 单价
                            key: 'price',
                            minWidth: 80,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t54'), // 数量
                            key: 'quantity',
                            minWidth: 80,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t86'), // 行金额
                            key: 'lineAmount',
                            minWidth: 80,
                            align: 'center',
                            render: (h, params) => {
                                const { lineAmount } = params.row;
                                return h('span', lineAmount ? parseFloat(lineAmount.toFixed(2)) : '');
                            },
                        },
                    ]
                },
                tableData: [],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                },
                tableButtons: {
                    customButtons: [
                        {
                            label: this.$t('fpzInvaccCommon.t32'),
                            type: 'primary',
                            icon: 'archive',
                            size: 'small',
                            click: (button) => {
                                exportExcel(button, this, this.gscInvoiceForm, `/gscint/hw/${this.isCG ? 'ispcgzx' : 'ispInvoice'}/exportLines`);
                            }
                        }
                    ]
                }
            },
            itemLines: {
                columns: {
                    columns: [
                        {
                            title: this.$t('gscInvoice.t50'), // 物料编码
                            key: 'itemCode',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t51'), // 物料描述
                            key: 'itemName',
                            minWidth: 150,
                            tooltip: true
                        },
                        {
                            title: this.$t('gscInvoice.t87'), // 开票数量
                            key: 'quantity',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t88'), // 不含税单价
                            key: 'price',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t13'), // 不含税金额
                            key: 'lineAmount',
                            minWidth: 100,
                            align: 'center'
                        },
                    ]
                },
                tableData: [],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                }
            },
            acceptLines: {
                columns: {
                    columns: [
                        {
                            title: this.$t('gscInvoice.t49'), // 送货单号
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t45'), // 接收单号
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t50'), // 物料编码
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t51'), // 物料描述
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t87'), // 开票数量
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t88'), // 不含税单价
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                        {
                            title: this.$t('gscInvoice.t13'), // 不含税金额
                            key: '',
                            minWidth: 100,
                            align: 'center'
                        },
                    ]
                },
                tableData: [],
                loading: false,
                settings: {
                    needPager: true,
                    showElevator: true,
                    showSizer: true,
                    pageSizeOpts: [10, 20, 50, 100],
                    needSearch: false,
                    needValidation: true,
                    currentPage: 1,
                    pageSize: 10,
                    total: null,
                    submitLoading: false
                },
                ispInvoiceId: '',
            },
            // rule: /^-?(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
            fkTotal: 0,
            INT_BALANCE_AMOUNT: [],
            INT_TAX_RATE: [],
        }
    },
    methods: {
        /* 自动勾选 */
        autoSelect () {
            this.$nextTick(() => {
                const salesReturnRef = this.$refs.salesReturn;
                if (this.isPenaltyInvoice || !salesReturnRef) return;
                const { objData } = salesReturnRef.$refs.iTable.$refs.iTable;
                Object.keys(objData).forEach(i => {
                    objData[i]._isChecked = false;
                    if (this.salesReturn.selection.find((item) => item.transactionId === objData[i].transactionId)) {
                        objData[i]._isChecked = true;
                    }
                    /* 正常开票类型退货数据必须勾选 */
                    if (this.gscInvoiceForm.invoiceType !== 'Penalty' && this.salesReturn.mustSelection.some((item) => item.transactionId === objData[i].transactionId)) {
                        objData[i]._isDisabled = true;
                        objData[i]._isChecked = true;
                    }
                });
                // for (const i in objData) {
                //     // mjControlSwitch
                //     objData[i]._isChecked = false;
                //     if (this.salesReturn.selection.find((item) => item.transactionId === table[i].transactionId)) {
                //         objData[i]._isChecked = true;
                //     }
                //     /* 正常开票类型退货数据必须勾选 */
                //     if (this.gscInvoiceForm.invoiceType !== 'Penalty' && this.salesReturn.mustSelection.find((item) => item.transactionId === table[i].transactionId)) {
                //         debugger;
                //         objData[i]._isDisabled = true;
                //         objData[i]._isChecked = true;
                //     }
                // }
                /* 计算汇总金额 */
                this.countTotal();
            });
        },
        ouChange (val) {
            queryVendorSite(val, this.vendorCode)
            .then((res) => {
                let {data} = res.data.data;
                if (data) {
                    data.forEach((item, index) => {
                        data[index] = {
                            label: item,
                            value: item
                        }
                    });
                    this.vendorSiteList = data;
                    /* 只有一条数据，默认带出 */
                    if (data.length === 1) {
                        this.gscInvoiceForm.vendorSiteCode = data[0].value;
                    }
                }
            });
            queryCurrencyCode(val, this.vendorCode)
            .then((res) => {
                let {data} = res.data.data;
                if (data) {
                    data.forEach((item, index) => {
                        data[index] = {
                            label: item,
                            value: item
                        }
                    });
                    this.currencyCodeList = data;
                    if (data.length === 1) {
                        this.gscInvoiceForm.currencyCode = data[0].value;
                    }
                }
            })
        },
        invoiceAddNext () {
            this.$refs.gscinvoiceForm.validate((vaild) => {
                if (vaild) {
                    this.salesReturn.selection = [];
                    this.salesReturn.mustSelection = [];
                    this.ispCheck();
                    queryIntTimeZone(this.gscInvoiceForm.orgId, (data) => {
                        this.offsetTime = data;
                    });
                }
            });
        },
        goBack () {
            this.$closeTab({
                name: 'gscInvoiceAdd'
            });
            this.$router.push({
                name: 'gscInvoice'
            });
        },
        taxCodeChange (val) {
            this.gscInvoiceForm.taxRate = this.taxRateCodeList.find((item) => item.code === val).value;
        },
        queryLinesApi(keyName, url, ispInvoiceId = null, hasPage = true, data = {}) {
            this[keyName].loading = true;
            const { currentPage, pageSize } = this[keyName].settings;
            const postData = ispInvoiceId ? { ispInvoiceId } : this.gscInvoiceForm;
            return axios.post(url, {
                ...postData,
                vendorCode: this.vendorCode,
                pageNum: currentPage,
                pageSize,
                ...data,
            })
                .then((res) => {
                    this[keyName].loading = false;
                    if (hasPage) {
                        const { list, total } = res.data.data;
                        this[keyName].tableData = list;
                        this[keyName].settings.total = total;
                    } else {
                        this[keyName].tableData = res.data.data || [];
                    }
                })
                .catch(() => {
                    this[keyName].loading = false;
                });
        },
        /* 创建ISP发票-接收退货明细列表 */
        queryIapReceips2() {
            return this.queryLinesApi('salesReturn', `/gscint/hw/${this.isCG ? 'ispcgzx' : 'ispInvoice'}/queryIapReceips2`, null, true, {
                materialDetailNos: this.materialDetailNo,
                logisticsTrackingNos: this.logisticsTrackingNo,
            });
        },
        queryIapReceips2Bymater() {
            this.queryIapReceips2()
                .then(() => {
                    /* 根据母卷号、物流单号查询后，清除用户勾选的内容 */
                    this.salesReturn.selection = [...this.salesReturn.mustSelection];
                });
        },
        /* 创建ISP发票-罚扣款列表 */
        queryPenaltys() {
            this.queryLinesApi('penaltyDeduction', '/gscint/hw/ispInvoice/queryPenaltys')
                .then(() => {
                    if (this.isPenaltyInvoice) {
                        this.$nextTick(() => {
                            const table = this.$refs.penaltyDeduction.$refs.iTable.$refs.iTable.objData;
                            // eslint-disable-next-line no-restricted-syntax
                            for (const i in table) {
                                // eslint-disable-next-line no-prototype-builtins
                                if (table.hasOwnProperty(i)) {
                                    if (this.penaltyAllFlag) {
                                        // eslint-disable-next-line no-underscore-dangle
                                        table[i]._isDisabled = true;
                                        // eslint-disable-next-line no-underscore-dangle
                                        table[i]._isChecked = true;
                                    } else {
                                        // eslint-disable-next-line no-lonely-if
                                        if (this.penaltyIds.includes(table[i].penaltyId)) {
                                            // eslint-disable-next-line no-underscore-dangle
                                            table[i]._isChecked = true;
                                        }
                                    }
                                }
                            }
                        });
						/* 获取所有罚扣的数据 */
                        axios.post('/gscint/hw/ispInvoice/queryPenaltyAlls', {
                            ...this.gscInvoiceForm,
                            vendorCode: this.vendorCode,
                        })
                            .then((res) => {
                                const { data } = res.data;
                                if (data) {
                                    this.penaltyAllData = data;
                                }
                            });
                    }
                });
        },
        salesReturnOnSelect (selection, row) {
            const {transactionId, parentTransactionId} = row;
            const table = this.salesReturn.tableData;
            /* 根据规则自动勾选正负数据 */
            if ([table[0], table[table.length - 1]].find((item) => item.transactionId === transactionId)) {
                this.getRequired(transactionId, parentTransactionId);
            } else {
                this.$nextTick(() => {
                    this.salesReturn.selection.push(
                        ...this.salesReturn.tableData.filter((item) => (row.transactionId === row.parentTransactionId ? (item.transactionId !== row.parentTransactionId) : (item.transactionId === row.parentTransactionId)) && item.parentTransactionId === row.parentTransactionId)
                    )
                });
            }

        },
        salesReturnOnSelectChange (selection) {
            console.log(selection);
            this.salesReturn.selection = this.salesReturn.selection.filter((item) => !this.salesReturn.tableData.find((item2) => item.transactionId === item2.transactionId));
            this.salesReturn.selection.push(...selection);
            /* 计算汇总金额 */
            this.countTotal();
            if (selection.length === 0) {
                this.salesReturn.allSelectFlag = false;
            }
        },
        salesReturnOnCancel (selection, row) {
            this.salesReturn.selection = this.salesReturn.selection.filter((item) => item.transactionId !== row.transactionId && item.parentTransactionId !== row.parentTransactionId);
            /* 自动取消正负数据 */
            this.$nextTick(() => {
                this.salesReturn.selection = this.salesReturn.selection.filter((item) => item.parentTransactionId  !== row.parentTransactionId);
            });
            console.log(this.salesReturn.selection, row, 'selection');
            this.salesReturn.allSelectFlag = false;
        },
        salesReturnOnSelectAll (selection) {
            this.salesReturn.selection.push(...selection);
        },
        salesReturnOnPageChange (currentPage, pageSize) {
            this.salesReturn.settings.currentPage = currentPage;
            this.queryIapReceips2();
        },
        salesReturnOnPageSizeChange (currentPage, pageSize) {
            this.salesReturn.settings.currentPage = 1;
            this.salesReturn.settings.pageSize = pageSize;
            this.queryIapReceips2();
        },
        penaltyDeductionOnPageChange (currentPage, pageSize) {
            this.penaltyDeduction.settings.currentPage = currentPage;
            this.queryPenaltys();
        },
        penaltyDeductionOnPageSizeChange (currentPage, pageSize) {
            this.penaltyDeduction.settings.currentPage = 1;
            this.penaltyDeduction.settings.pageSize = pageSize;
            this.queryPenaltys();
        },
        ispSave () {
            /* 独立罚扣一定要勾选数据 */
            if (this.isPenaltyInvoice && this.penaltyIds.length === 0 && !this.penaltyAllFlag) {
                this.$Modal.warning({
                    content: this.$t('gscInvoice.t126'), // 请勾选数据
                });
                return;
            }
            this.loading = true;
            const postData = {
                ...this.gscInvoiceForm,
                vendorCode: this.vendorCode,
                lines: this.salesReturn.selection.map((item) => item.transactionId),
                penaltyAllFlag: this.penaltyAllFlag ? 'Y' : 'N',
                penaltyIds: this.penaltyIds,
            };
            axios.post('/gscint/hw/ispInvoice/save', postData)
            .then((res) => {
                this.loading = false;
                let {code, message} = res.data.data;
                if (code === 1) {
                    this.$Modal.success({
                        content: this.$t('gscInvoice.t100')
                    });
                    this.$closeTab({
                        name: 'gscInvoiceAdd'
                    });
                } else {
                    this.showErrorTips('loading', message);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* ISP 提交 */
        ispSubmit (closeTabName = 'gscInvoiceDetail') {
            this.loading = true;
            axios.post('/gscint/hw/ispInvoice/submit', {
                ispInvoiceId: this.ispInvoiceId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.loading = false;
                let {code, message} = res.data.data;
                if (code === 1) {
                    this.$Modal.success({
                        content: this.$t('gscInvoice.t101')
                    });
                    this.$closeTab({
                        name: closeTabName
                    });
                } else {
                    this.showErrorTips('loading', message || '');
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* 查询税控发票 */
        queryTcm (ispInvoiceId) {
            return this.queryLinesApi('skjInvoice', '/gscint/hw/tcmInvoice/query', ispInvoiceId, false);
        },
        /* 根据ID获取头信息 */
        queryHeaderById (ispInvoiceId) {
            return axios.post('/gscint/hw/ispInvoice/queryHeader', {
                ispInvoiceId,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                let {data} = res.data;
                if (data) {
                    let {orgId} = data;
                    this.gscInvoiceForm = {
                        ...data,
                        orgId: String(orgId)
                    }
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        addTcmLine () {
            this.skjInvoice.tableData.push({
                ispInvoiceId: this.ispInvoiceId,
                ispInvoiceCode: '',
                invoiceType: this.gscInvoiceForm.invoiceType,
                taxInvoiceNumber: '',
                taxInvoiceType: '',
                createInvoiceDate: '',
                totalAmount: '',
                noTaxAmount: '',
                taxAmount: '',
                vendorCode: this.vendorCode,
                taxRate: this.gscInvoiceForm.taxRate,
                invoiceQty: '',
            });
        },
        endDateChange (val) {
            this.gscInvoiceForm.endDate = val ? moment(val).format('YYYY-MM-DD') : '';
        },
        /* 开票规则 */
        getIapInvoiceRule () {
            let {orgId, vendorSiteCode} = this.gscInvoiceForm;
            axios.post('/gscint/hw/finance/getIapInvoiceRule', {
                orgId,
                vendorSiteCode,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                let {PENALTY_PERCENT} = res.data.data.data;
                this.gscInvoiceForm.penaltyPercent = PENALTY_PERCENT;
            });
        },
        /* 创建ISP发票-校验 */
        ispCheck () {
            this.loading = true;
            let {taxCode} = this.gscInvoiceForm;
            axios.post('/gscint/hw/ispInvoice/check', {
                vendorCode: this.vendorCode,
                ...this.gscInvoiceForm,
                endDateFormart: undefined,
                taxRate: this.taxRateCodeList.find((item) => item.code === taxCode).value
            })
            .then(async (res) => {
                this.loading = false;
                let {code, message} = res.data.data;
                if (code === 1) {
                    this.step = 2;
                    if (this.gscInvoiceForm.invoiceType === 'Material Invoice') {
                        await this.getDefaultRequired();
                        await this.getPenaltyAmountSum();
                        this.queryIapReceips2();
                        this.getIapInvoiceRule();
                    }
                    this.queryPenaltys();
                } else {
                    this.showErrorTips('loading', message);
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        /* 计算汇总 */
        countTotal () {
            /*           
                汇总金额计算逻辑：
                a代表 罚扣总余额的绝对值，b代表 (勾选开票明细金额 * 最大高低开比例) 的绝对值
                (1) 如果是正数，即低开罚扣。
                    若 a>b， 则汇总金额等于勾选开票明细金额总和 - （勾选开票明细金额总和 * 最大高低开比例）的绝对值
                    若 a<=b，则汇总金额等于勾选开票明细金额总和 - 罚扣总余额的绝对值
                (2) 如果是负数，即为高开罚扣。
                    若 a>则汇总金额等于勾选开票明细金额总和 + （勾选开票明细金额总和 * 最大高低开比例）的绝对值
                    若 a<=b，则汇总金额等于勾选开票明细金额总和 + 罚扣总余额的绝对值
            */
            let total = 0; // 开票明细金额总和
            let fkTotal = this.fkTotal; // 罚扣款余额
            this.salesReturn.selection.forEach((item) => {
                total += item.lineAmount;
            });
            let isPositive = fkTotal > 0; // 是否正数
            let penaltyPercent = this.gscInvoiceForm.penaltyPercent / 100; // 高低开比例
            let fkTotalAbs = Math.abs(fkTotal);
            let totalAbs = Math.abs(total * penaltyPercent); // （开票明细金额总和 * 最大高低开比例）的绝对值
            
            if (fkTotalAbs > totalAbs) {  // a > b
                if (isPositive) {
                    total -= totalAbs;
                } else {
                    total += totalAbs;
                }
            } else { // a <= b
                if (isPositive) {
                    total -= fkTotalAbs; 
                } else {
                    total += fkTotalAbs;
                }
            }
            this.gscInvoiceForm.totalAmount = total.toFixed(2);
        },
        /* 查看-ISP发票行 */
        queryLines (ispInvoiceId) {
            this.queryLinesApi('ispLines', '/gscint/hw/ispInvoice/queryLines', ispInvoiceId);
        },
        /* 查看-罚扣款行 */
        queryIspPenaltys (ispInvoiceId) {
            this.queryLinesApi('kfkLines', '/gscint/hw/ispInvoice/queryIspPenaltys', ispInvoiceId);
        },
        skjInvoiceOnPageSizeChange (currentPage, pageSize) {
            this.skjInvoice.settings.currentPage = currentPage;
            // this.queryLines();
        },
        skjInvoiceOnPageChange (currentPage, pageSize) {
            this.skjInvoice.settings.currentPage = 1;
            this.skjInvoice.settings.pageSize = pageSize;
            // this.queryLines();
        },
        kfkLinesOnPageChange (currentPage, pageSize) {
            this.kfkLines.settings.currentPage = currentPage;
            this.queryIspPenaltys(this.ispInvoiceId);
        },
        kfkLinesOnPageSizeChange (currentPage, pageSize) {
            this.kfkLines.settings.currentPage = 1;
            this.kfkLines.settings.pageSize = pageSize;
            this.queryIspPenaltys(this.ispInvoiceId);
        },
        ispLinesOnPageChange (currentPage, pageSize) {
            this.ispLines.settings.currentPage = currentPage;
            this.queryLines(this.ispInvoiceId);
        },
        ispLinesOnPageSizeChange (currentPage, pageSize) {
            this.ispLines.settings.currentPage = 1;
            this.ispLines.settings.pageSize = pageSize;
            this.queryLines(this.ispInvoiceId);
        },
        /* 物料汇总 */
        queryLineSummary (ispInvoiceId) {
            this.queryLinesApi('itemLines', '/gscint/hw/ispInvoice/queryLineSummary', ispInvoiceId);
        },
        itemLinesOnPageChange (currentPage, pageSize) {
            this.itemLines.settings.currentPage = currentPage;
            this.queryLineSummary(this.ispInvoiceId);
        },
        itemLinesOnPageSizeChange (currentPage, pageSize) {
            this.itemLines.settings.currentPage = 1;
            this.itemLines.settings.pageSize = pageSize;
            this.queryLineSummary(this.ispInvoiceId);
        },
        // acceptLinesOnSubmit () {},
        // acceptLinesOnPageSizeChange () {},
        // acceptLinesOnPageChange () {}
        /* 税控发票作废 */
        tcmCancel (taxInvoiceId) {
            return axios.post('/gscint/hw/tcmInvoice/cancel', {
                ispInvoiceId: this.ispInvoiceId,
                vendorCode: this.vendorCode,
                taxInvoiceId
            });
        },
        /* 税控发票录入保存 */
        tcmSave (hasTips = true) {
            const requiredKeys = ['taxInvoiceNumber', 'createInvoiceDate', 'noTaxAmount', 'totalAmount'].concat(this.invoiceQtySwitch ? ['invoiceQty'] : []);
            let tips = [];
            this.skjInvoice.tableData.forEach((item) => {
                requiredKeys.forEach((key) => {
                    if (!item[key]) {
                        tips.push(`${this.skjInvoice.columns.columns.find((col) => col.key === key).title}${this.$t('gscInvoice.t104')}${['noTaxAmount', 'totalAmount'].includes(key) ? `，${this.$t('gscInvoice.t132')}` : ''}</br>`)
                    }
                });
            });
            if (this.invoiceQtySwitch) {
                const invoiceQtyTotal = this.skjInvoice.tableData.reduce((prev, next) => {
                    return BigNumber(prev).plus(BigNumber(next.invoiceQty));
                }, 0).toNumber();
                debugger;
                if (this.gscInvoiceForm.totalQuantity != invoiceQtyTotal) {
                    tips.push(this.$t('gscInvoice.t131')); // 开票数量必须与GSC发票明细行数量汇总相等
                }
            }
            return new Promise((resolve, reject) => {
                if (tips.length === 0) {
                    const {totalAmount, noTaxAmount, currencyCode, orgId} = this.gscInvoiceForm;
                    // let totalAmount = this.gscInvoiceForm.totalAmount; // 发票含税金额
                    // let noTaxAmount = this.gscInvoiceForm.noTaxAmount;// 发票不含税金额
                    // this.skjInvoice.tableData
                    const skjInvoice = this.skjInvoice.tableData.reduce((prev, { totalAmount, noTaxAmount }) => {
                        Object.assign(prev, {
                            totalAmount: new BigNumber(prev.totalAmount).plus(totalAmount).toNumber(),
                            noTaxAmount: new BigNumber(prev.noTaxAmount).plus(noTaxAmount).toNumber(),
                        })
                        return prev;
                    }, {
                        totalAmount: 0,
                        noTaxAmount: 0,
                    });
                    const balanceAmountObj = this.INT_BALANCE_AMOUNT.find((item) => item.code === orgId);
                    let moneyObj = {};
                    balanceAmountObj && balanceAmountObj.value.split('|').forEach((item) => {
                        const keyVal = item.split('-');
                        const label = keyVal[0];
                        const value = keyVal[1];
                        moneyObj[label] = {
                            label,
                            value,
                        };
                    });
                    // const moneyObj = {
                    //     'THB': {
                    //         value: 'value',
                    //         label: '泰铢',
                    //         labelEn: 'THB'
                    //     },
                    //     'CNY': {
                    //         value: 'attribute1',
                    //         label: '人民币',
                    //         labelEn: 'CNY'
                    //     },
                    //     'USD': {
                    //         value: 'attribute2',
                    //         label: '美元',
                    //         labelEn: 'USD'
                    //     }
                    // }
                    const diffPrice = moneyObj[currencyCode] ? Number(moneyObj[currencyCode].value) : 0; // 价差
                    // taxAmount noTaxAmount
                    const tips = `${diffPrice}${moneyObj[currencyCode] && moneyObj[currencyCode].label || currencyCode}`;
                    let totalAmountDiff = Math.abs(totalAmount - skjInvoice.totalAmount);
                    let noTaxAmountDiff = Math.abs(noTaxAmount - skjInvoice.noTaxAmount);
                    if (totalAmountDiff > diffPrice) {
                        this.$Modal.warning({
                            content: `${this.$t('gscInvoice.t112')}${tips}`
                        });
                        return false;
                    }
                    if (noTaxAmountDiff > diffPrice) {
                        this.$Modal.warning({
                            content: `${this.$t('gscInvoice.t113')}${tips}`
                        });
                        return false;
                    }
                    if (totalAmountDiff > 0) {
                        this.$Modal.confirm({
                            content: `${this.$t('gscInvoice.t114')}${totalAmountDiff.toFixed(2)}${this.$t('gscInvoice.t116')}`,
                            onOk: () => {
                                this.saveFn(resolve, reject, hasTips);
                            }
                        })
                        return false;
                    }
                    if (noTaxAmountDiff > 0) {
                        this.$Modal.confirm({
                            content: `${this.$t('gscInvoice.t115')}${noTaxAmountDiff.toFixed(2)}${this.$t('gscInvoice.t116')}`,
                            onOk: () => {
                                this.saveFn(resolve, reject, hasTips);
                            }
                        })
                        return false;
                    }
                    this.saveFn(resolve, reject, hasTips);
                } else {
                    this.$Modal.warning({
                        content: tips.join('')
                    });
                    reject();
                }
            })
        },
        saveFn (resolve, reject, hasTips) {
            this.loading = true;
            let datas = this.skjInvoice.tableData;
            axios.post(`/gscint/hw/${this.isCG ? 'tcmcgzx' : 'tcmInvoice'}/save`, {
                ispInvoiceId: this.ispInvoiceId,
                vendorCode: this.vendorCode,
                orgId: this.gscInvoiceForm.orgId,
                datas
            })
            .then(async (res) => {
                this.loading = false;
                let {code, message} = res.data.data;
                if (code === 1) {
                    if (hasTips) {
                        setTimeout(() => {
                            this.$Modal.success({
                                content: this.$t('gscInvoice.t105')
                            });
                        }, 500);
                    }
                    await this.queryTcm(this.ispInvoiceId);
                    resolve();
                } else {
                    setTimeout(() => {
                        this.showErrorTips('loading', message);
                    }, 500);
                    reject();
                }
            })
            .catch(() => {
                this.showErrorTips();
                reject();
            });
        },
        /* 默认勾选退货数据 */
        getDefaultRequired () {
            return axios.post('/gscint/hw/ispInvoice/getDefaultRequired', {
                vendorCode: this.vendorCode,
                ...this.gscInvoiceForm
            })
            .then((res) => {
                let data = res.data.data;
                if (data) {
                    this.salesReturn.mustSelection = [...data];
                    this.salesReturn.selection = data;
                }
            });
        },
        /* 正负勾选退货（当页第一条或最后一条数据调用） */
        getRequired (transactionId, parentTransactionId) {
            axios.post('/gscint/hw/ispInvoice/getRequired', {
                vendorCode: this.vendorCode,
                ...this.gscInvoiceForm,
                transactionId,
                parentTransactionId
            })
            .then((res) => {
                let data = res.data.data;
                if (data) {
                    data.filter((item) => item.transactionId !== transactionId).forEach((item) => {
                        this.salesReturn.selection.push(item);
                    });
                    // this.autoSelect();
                }
            });
        },
        /* 退货数据全选 */
        getAllRequired (val) {
            if (val) {
                this.salesReturn.loading = true;
                axios.post(`/gscint/hw/${this.isCG ? 'ispcgzx' : 'ispInvoice'}/getAllRequired`, {
                    vendorCode: this.vendorCode,
                    ...this.gscInvoiceForm,
                    materialDetailNos: this.materialDetailNo,
                    logisticsTrackingNos: this.logisticsTrackingNo,
                })
                .then((res) => {
                    this.salesReturn.loading = false;
                    let data = res.data.data;
                    if (data) {
                        this.salesReturn.selection = data;
                        // this.autoSelect();
                    } else {
                        this.salesReturn.allSelectFlag = false;
                        this.showErrorTips();
                    }
                });
            } else {
                this.salesReturn.selection = [...this.salesReturn.mustSelection]
                // this.autoSelect();
            }
        },
        async tcmSubmit () {
            await this.tcmSave(false);
            this.ispSubmit('gscInvoiceEdit');
        },
        salesReturnExport () {
            exportExcel(this.salesReturn, this, { 
                ...this.gscInvoiceForm,
                materialDetailNos: this.materialDetailNo,
                logisticsTrackingNos: this.logisticsTrackingNo,
            }, `/gscint/hw/${this.isCG ? 'ispcgzx' : 'ispInvoice'}/exportIapReceips2`);
        },
        async init () {
            getOuList((data) => {
                this.ouList = data;
            });
            /* 税率 */
            this.getDict('INT_TAX_RATE');
            /* 开票类型 */
            this.getDict('INT_GSC_INVOICE_SOURCE_TYPE', (data) => {
                this.INT_GSC_INVOICE_SOURCE_TYPE = data;
            });
            /* 发票状态 */
            this.getDict('INT_GSC_INVOICE_STATUS');
            /* 币种 */
            this.getDict('INT_CURRENCY', (data) => {
                this.currencyCodeList = data;
            });
            /* 国际价差 */
            this.getDict('INT_BALANCE_AMOUNT');
            if (!this.isNew) {
                this.step = 2;
                let {ispInvoiceId} = this.$route.query;
                this.ispInvoiceId = ispInvoiceId;
                await this.queryHeaderById(ispInvoiceId);
                this.queryLines(ispInvoiceId)
                this.queryIspPenaltys(ispInvoiceId);
                this.queryLineSummary(ispInvoiceId);
                this.queryTcm(ispInvoiceId);
            }
            this.isLocal = location.hostname === 'localhost.midea.com';
            /* 采购中心OU */
            this.getDict('INT_CGZX_ORG');
            /* 采购中心母卷号强控开关 */
            this.getDict('INT_MASTER_ROLL_CONTROL');
            /* 采购中心开票数量强控 */
            this.getDict('INT_INVOICE_QTY_CONTROL');
        },
        selecionLog () {
            console.log('selection', this.salesReturn.selection);
        },
        /* 罚扣款金额查询 */
        getPenaltyAmountSum () {
            return axios.post('/gscint/hw/ispInvoice/getPenaltyAmountSum', {
                ...this.gscInvoiceForm,
                vendorCode: this.vendorCode
            })
            .then((res) => {
                this.fkTotal = res.data || 0;
            });
        },
        /* 跳转无价格开票明细 */
        goNoPriceDetail() {
            const { orgId, currencyCode, endDate, vendorSiteCode } = this.gscInvoiceForm;
            console.log(this.gscInvoiceForm);
            this.$router.push({
                name: 'noPriceDetails',
                query: {
                    orgId,
                    ouName: this.ouList.find((item) => item.value === orgId).label,
                    vendorSiteCode,
                    currencyCode,
                    endDate,
                    vendorCode: this.vendorCode,
                },
            });
        },
        /* 罚扣全选 */
        penaltyAllOnChange(val) {
            const table = this.$refs.penaltyDeduction.$refs.iTable.$refs.iTable.objData;
            for (let i in table) {
                table[i]._isDisabled = val;
                table[i]._isChecked = val;
            }
            this.penaltyIds = [];
            /* 汇总金额 */
            this.gscInvoiceForm.totalAmount = this.totalAmount;
        },
        penaltyDeductionOnSelect(selection) {
            if (this.penaltyAllFlag) return
            const tableIds = this.penaltyDeduction.tableData.map((item) => item.penaltyId);
            this.penaltyIds = Array.from(new Set(this.penaltyIds.filter((id) => !tableIds.includes(id)).concat(selection.map((item) => item.penaltyId))));
            /* 汇总金额 */
            this.gscInvoiceForm.totalAmount = this.totalAmount;
        },
        filterColumns(key) {
            return this.isCG ? this[key].columns.columns : this[key].columns.columns.filter((item) => !['materialDetailNo', 'logisticsTrackingNo', 'supplierContractNo', 'contractSubitemNo', 'poLineId'].includes(item.key));
        },
        countFun() {
            if (!this.isCG) return;
            const obj = this.skjInvoice.tableData.reduce((prev, next) => {
                prev.taxAmount = new BigNumber(prev.taxAmount || 0).plus(next.taxAmount || 0).toNumber();
                prev.noTaxAmount = new BigNumber(prev.noTaxAmount || 0).plus(next.noTaxAmount || 0).toNumber();
                prev.totalAmount = new BigNumber(prev.totalAmount || 0).plus(next.totalAmount || 0).toNumber();
                prev.invoiceQty = new BigNumber(prev.invoiceQty || 0).plus(next.invoiceQty || 0).toNumber();
                return prev;
            }, {
                taxAmount: 0,
                noTaxAmount: 0,
                totalAmount: 0,
                invoiceQty: 0,
            });
            Object.assign(this.skjInvoice.tableData2[0], obj);
        },
    },
    mounted () {
        this.init();
    },
    activated () {
        this.init();
    },
}
</script>
<style lang="less" scoped>
.invoice-layout {
    padding: 20px;
    background: #FFF;
}
.mt10 {
    margin-top: 10px;
}
.ml20 {
    margin-left: 20px;
}
.mr10 {
    margin-right: 10px;
}
.invoice-nodata {
    position: absolute;
    left: 0;
    top: 90px;
    width: 100%;
    text-align: center;
    z-index: 999;
    span {
        cursor: pointer;
        color: blue;
        text-decoration: underline;
    }
}
.gsc-invoice-total-table {
    border-top: none;
}
</style>